<template>
  <div id="jobLevel">
    <el-container>
      <el-aside width="340px" style="padding: 0;">
        <p style="height:90px;padding:10px;">
          <SearchWidget
            :placeholder="'请输入级别名字'"
            @bySearchVal="setSearchValOfJobLevel"
            class="searchInput"
            :width="'220px'"
            ref="searchJobLevel"
          ></SearchWidget>
          <el-button
            style="float:right;margin-top:6px;"
            icon="el-icon-plus"
            type="primary"
            @click="showEditJobLevelDialog('add', { id:'', levelName: '' })"
          >级别</el-button>
        </p>
        <p style="height:100%;overflow:auto;padding-bottom:100px;">
          <el-tree
            highlight-current
            @node-click="setCurrentJobLevel"
            :data="jobLevelList"
            node-key="id"
            default-expand-all
            :expand-on-click-node="false"
            :props="treeProps"
            ref="jobLevel"
            :filter-node-method="filterJobLevel"
          >
            <span class="custom-tree-node" slot-scope="{ node, data }">
              <p class="levelText">{{data.levelName}}</p>
              <span>
                <el-button
                  type="text"
                  @click.stop="showEditJobLevelDialog('edit', {
                    id:data.id,
                    levelName: data.levelName
                  })"
                  icon="el-icon-edit"
                  class="actionIcon"
                ></el-button>
                <el-button
                  type="text"
                  @click.stop="showDeleteJobLevelDialog(data)"
                  icon="el-icon-delete"
                  class="actionIcon"
                ></el-button>
              </span>
            </span>
          </el-tree>
        </p>
      </el-aside>
      <el-main v-show="jobLevelCurrent.id">
        <p style="text-align:left;margin-bottom:10px;font-size:16px;font-weight:500;">
          {{jobLevelCurrent.levelName}}
          <span
            style="color: #19be6b;font-size: 18px;margin-left: 10px;"
          >{{employeeNum}}人</span>
        </p>
        <el-divider></el-divider>
        <el-row style="margin-bottom:20px;">
          <el-col :span="8" style="text-align:left;">
            <search-widget
              :placeholder="'请输入员工的名字'"
              @bySearchVal="setSearchValOfEmployee"
              :width="'240px'"
              ref="searchEmployee"
            ></search-widget>
          </el-col>
          <el-col :span="6" :offset="10" style="text-align:right;">
            <el-button
              @click="() => {
                addEmployeeModalStatus = true;
              }"
            >添加人员</el-button>
          </el-col>
        </el-row>

        <Table :columns="tableColumn" :data="employeeTableData">
          <template slot-scope="{ row }" slot="departments">
            {{getDepartmentsName(row.departments)}}
          </template>
          <template slot-scope="{ row }" slot="action">
            <el-button
              type="danger"
              @click="deleteEmployee(row.id)"
              size="mini"
            >删除</el-button>
          </template>
        </Table>
        <Pagination
          :dataCount="total"
          @byPageSize="setPageSize"
          @byPageCurrent="setPageCurrent"
          ref="page"
        ></Pagination>
      </el-main>
    </el-container>

    <!-- 添加编辑职级弹窗 -->
    <Modal v-model="editJobLevelModalStatus" :title="modalConfig.modalTitle">
      <p style="text-align:center;">
        职级名称：
        <el-input
          v-model="editJobLevelInfo.levelName"
          placeholder="请输入职级名称"
          style="width:300px;"></el-input>
      </p>
      <div slot="footer">
        <el-button @click="()=> editJobLevelModalStatus = false">取消</el-button>
        <el-button @click="confirmEditJobLevel()">确定</el-button>
      </div>
    </Modal>

    <!-- 当前职级添加人员弹窗 -->
    <Modal v-model="addEmployeeModalStatus" :title="'添加人员'">
      <p style="margin-bottom:20px;font-size:14px;">
        职级：
        <span style="margin-left:38px;font-weight:900;">
          {{jobLevelCurrent.levelName}}
        </span>
      </p>
      <el-row :gutter="20" align="center" type="flex">
        <el-col :span="4" style="height:40px;line-height:40px;font-size:14px;">
          人员：
        </el-col>
        <el-col :span="6" style="text-align:left;">
          <SelectPeople
            :onlySelectEmployee="true"
            @byEmployee="setEmployee"
            :defaultShowText="'请选择员工'"
            ref="selectPeople"
            :clearSelectedItems="true"
          ></SelectPeople>
        </el-col>
      </el-row>
      <div slot="footer">
        <el-button @click="addEmployeeCancel">取消</el-button>
        <el-button @click="confirmAddEmployee()">确定</el-button>
      </div>
    </Modal>
  </div>
</template>

<script>
import Pagination from "@/components/page/pagination.vue";
import SearchWidget from "@/components/search/tableSearch.vue";
import SelectPeople from "@/components/business/selectEmployee/selectEmployee";

const breadData = [
  { text: "设置", url: "/management/setting" },
  { text: "报销设置", url: "/management/setting" },
  { text: "人员报销级别设置" }
];
const tableColumn = [
  { title: "工号", key: "employeeNumber", align: "center", minWidth: 150 },
  { title: "员工姓名", key: "employeeName", align: "center", minWidth: 150 },
  { title: "部门", slot: "departments", align: "center", minWidth: 300 },
  { title: "职位", key: "post", align: "center", minWidth: 150 },
  { title: "操作", slot: "action", align: "center", minWidth: 100 }
];
export default {
  components: {
    SearchWidget,
    Pagination,
    SelectPeople
  },
  created() {
    this.setJobLevelList();
  },
  watch: {
    pageConfig: {
      deep: true,
      handler(newValue, oldValue) {
        this.setEmployeeTableData();
      }
    },
    searchValOfEmployee: {
      handler(val) {
        if (this.pageConfig.from !== 1) {
          this.pageConfig.from = 1;
          return;
        }
        this.setEmployeeTableData();
      }
    },
    searchValOfJobLevel: {
      handler(val) {
        this.$refs.jobLevel.filter(val);
      }
    },
    "jobLevelCurrent.id": {
      handler(val) {
        if (!val) {
          return;
        }
        if (this.searchValOfEmployee) {
          this.$refs.searchEmployee.clearInputVal();
          return;
        }
        if (this.pageConfig.from !== 1) {
          this.pageConfig.from = 1;
          return;
        }
        this.setEmployeeTableData();
        this.setEmployeeNum(val);
      }
    }
  },
  computed: {
    modalConfig() {
      if (this.type === "add") {
        return {
          successText: "添加成功",
          modalTitle: "添加职级序列",
          confirmAction: this.$api.addJobLevel
        };
      }
      if (this.type === "edit") {
        return {
          successText: "修改成功",
          modalTitle: "修改职级序列",
          confirmAction: this.$api.editJobLevel
        };
      }
    },
    requestTableParameter() {
      var parameter = {
        conditions: [],
        size: this.pageConfig.size,
        from: this.pageConfig.from,
        id: this.jobLevelCurrent.id
      };
      if (this.searchValOfEmployee) {
        parameter.conditions.push({
          field: "employeeName",
          value: this.searchValOfEmployee
        });
      }
      return parameter;
    }
  },
  data() {
    return {
      treeProps: {
        label: "levelName",
        children: "children"
      },
      //选中的级别
      jobLevelCurrent: {
        id: "",
        levelName: ""
      },
      //编辑的级别
      jobLevelEditing: {},
      //级别列表
      jobLevelList: [],
      editJobLevelModalStatus: false,
      addEmployeeModalStatus: false,
      //当前是新增还是编辑
      type: "add",
      editJobLevelInfo: {
        levelName: "",
        id: ""
      },
      addEmployeeInfo: {
        id: "",
        adds: []
      },
      searchValOfJobLevel: "",
      searchValOfEmployee: "",
      pageConfig: {
        from: 1,
        size: 10
      },
      total: 0,
      employeeTableData: [],
      employeeNum: 0,
      tableColumn: tableColumn,
      breadData: breadData
    };
  },
  methods: {
    //编辑或新增职级
    confirmEditJobLevel() {
      if (!this.editJobLevelInfo.levelName) {
        return this.$Message.error("职级的名字不能为空");
      }
      this.modalConfig.confirmAction(this.editJobLevelInfo).then(res => {
        this.$Message.success(this.modalConfig.successText);
        this.editJobLevelModalStatus = false;
        this.jobLevelCurrent = {
          id: "",
          levelName: ""
        };
        this.setJobLevelList();
      });
    },

    filterJobLevel(value, data) {
      if (!value) {
        return true;
      }
      return data.levelName.indexOf(value) >= 0;
    },

    getDepartmentsName(departments) {
      if (!departments) {
        return ''
      }
      return departments
        .map(item => item.departmentName)
        .join('，')
    },

    //添加人员弹窗取消事件
    addEmployeeCancel() {
      this.$refs.selectPeople.handlerClean();
      this.addEmployeeModalStatus = false;
    },

    //添加人员弹窗确定事件
    confirmAddEmployee() {
      if (!this.addEmployeeInfo.adds.length) {
        return this.$Message.error("请至少选择一个人员！");
      }
      this.addEmployeeInfo.id = this.jobLevelCurrent.id;
      this.addOrDeleteEmployeeAtCurrentJobLevel(
        this.addEmployeeInfo,
        "添加成功！",
        "add"
      );
    },

    //删除人员
    deleteEmployee(id) {
      this.$Modal.confirm({
        title: "确定要将该人员删除吗？",
        onOk: () => {
          var requestData = {
            id: this.jobLevelCurrent.id,
            deletes: []
          };
          requestData.deletes.push(id);
          this.addOrDeleteEmployeeAtCurrentJobLevel(
            requestData,
            "删除成功！",
            "delete"
          );
        }
      });
    },

    //添加或者删除人员
    addOrDeleteEmployeeAtCurrentJobLevel(requestData, successText, type) {
      this.$api.addOrDeleteEmployeeAtJobLevel(requestData, requestData.id).then(() => {
        if (type === "add") {
          this.$refs.selectPeople.handlerClean();
          this.addEmployeeModalStatus = false;
        }
        this.$Message.success(successText);
        if (this.searchValOfEmployee) {
          this.$refs.searchEmployee.clearInputVal();
          return;
        }
        if (this.pageConfig.from !== 1) {
          this.pageConfig.from = 1;
          return;
        }
        this.setEmployeeTableData();
        this.setEmployeeNum(this.jobLevelCurrent.id);
      });
    },

    //选取的人员
    setEmployee(val) {
      this.addEmployeeInfo.adds = val.map(item => item.id);
    },

    //搜索职级的字段
    setSearchValOfJobLevel(fields) {
      this.searchValOfJobLevel = fields;
    },

    //搜索人员的字段
    setSearchValOfEmployee(fields) {
      this.searchValOfEmployee = fields;
    },

    //分页
    setPageSize(val) {
      this.pageConfig.size = val;
    },

    setPageCurrent(val) {
      this.pageConfig.from = val;
    },

    //获取职级列表
    setJobLevelList() {
      this.$api.getJobLevelList().then(res => {
        this.jobLevelList = res;
        if (!res || !res.length) {
          return;
        }
        if (this.searchValOfJobLevel) {
          this.$refs.searchJobLevel.clearInputVal();
        }
        //设置默认值
        if (!this.jobLevelCurrent.id) {
          this.jobLevelCurrent = res[0];
          this.$nextTick(() => {
            this.$refs.jobLevel.setCurrentKey(this.jobLevelCurrent.id);
          });
        }
      });
    },

    //切换当前职级
    setCurrentJobLevel(data) {
      this.jobLevelCurrent = data;
    },

    //当前职级下的人员列表
    setEmployeeTableData() {
      this.$api.getEmployeeByJobLevel(this.requestTableParameter, this.requestTableParameter.id)
        .then(res => {
        this.employeeTableData = res.records;
        this.total = res.total;
      });
    },

    //当前职级下的人员数量
    setEmployeeNum(id) {
      this.$api.getEmployeeNumByJobLevel(id).then(res => {
        this.employeeNum = res;
      });
    },

    //删除职级的确定弹窗
    showDeleteJobLevelDialog(data) {
      this.$Modal.confirm({
        title: "请注意，此操作会删除此职级下的所有人员",
        content:
          "<p style='font-size:16px;font-weight:900;'>确定要删除“" +
          data.levelName +
          "”这个职级吗？</p>",
        onOk: () => {
          this.deleteJobLevel(data);
        }
      });
    },

    //新增或编辑职级的弹窗
    showEditJobLevelDialog(type, data) {
      this.type = type;
      this.editJobLevelModalStatus = true;
      this.editJobLevelInfo = data;
    },

    //删除职级
    deleteJobLevel(data) {
      this.$api.deleteJobLevel(data, data.id).then(() => {
        this.$Message.success("删除成功！");
        this.jobLevelCurrent = {
          id: "",
          levelName: ""
        };
        this.setJobLevelList();
      });
    }
  }
};
</script>

<style scoped>
#jobLevel {
  margin:20px;
}
.el-aside {
  background-color: #fff;
  color: #333;
  text-align: center;
  overflow: hidden;
}
.searchInput {
  height: 50px;
  line-height: 50px;
  float: left;
}

.el-main {
  margin-left: 20px;
  background-color: #e9eef3;
  color: #333;
  text-align: center;
}
.el-container {
  height: 100%;
}
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
  padding-right: 10px;
}
::v-deep .el-tree-node__content {
  height: 40px !important;
}
.actionIcon {
  font-size: 18px;
  padding: 10px 5px;
}
.levelText {
  width: 220px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: left;
}
</style>
